// Global fetch router: send GETs to READ base, non-GETs to WRITE base, and /api/admin to ADMIN base.
// Configured via env at build time.
// - REACT_APP_API_BASE: default (write/admin) API base, e.g., https://api.sbcctears.com
// - REACT_APP_API_READ_BASE: optional read API base, e.g., https://api-read.sbcctears.com
// - REACT_APP_API_WRITE_BASE: optional write API base, e.g., https://api-write.sbcctears.com
// - REACT_APP_API_ADMIN_BASE: optional admin API base, e.g., https://api-admin.sbcctears.com

/* eslint-disable no-undef */
const DEFAULT_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5000';
const READ_BASE = process.env.REACT_APP_API_READ_BASE || DEFAULT_BASE;
const WRITE_BASE = process.env.REACT_APP_API_WRITE_BASE || DEFAULT_BASE;
const ADMIN_BASE = process.env.REACT_APP_API_ADMIN_BASE || DEFAULT_BASE;

// Only patch in browsers
if (typeof window !== 'undefined' && typeof window.fetch === 'function') {
  const origFetch = window.fetch.bind(window);

  window.fetch = (input, init = {}) => {
    try {
  const method = String((init && init.method) || 'GET').toUpperCase();

      // Resolve URL string for inspection/rewrite
      let urlStr = typeof input === 'string' ? input : (input && input.url) || '';
      if (!urlStr) return origFetch(input, init);

      // Compute pathname safely
      let pathname = '';
      try {
        const u = new URL(urlStr, WRITE_BASE);
        pathname = u.pathname || '';
      } catch {
        pathname = '';
      }

      // Admin endpoints: route to ADMIN base (from default base)
      if (pathname.startsWith('/api/admin') && ADMIN_BASE && DEFAULT_BASE && typeof urlStr === 'string' && urlStr.startsWith(DEFAULT_BASE)) {
        const rewritten = ADMIN_BASE + urlStr.slice(DEFAULT_BASE.length);
        if (typeof input === 'string') {
          return origFetch(rewritten, init);
        }
        try {
          const req = new Request(rewritten, input);
          return origFetch(req, init);
        } catch {
          return origFetch(rewritten, init);
        }
      }

      // SAFE OPTION 3 ADAPTATION:
      // Instead of globally pointing WRITE_BASE to admin (which would break /api/picks, /api/entries if admin variant lacks them),
      // selectively route ONLY week & game mutation operations to ADMIN_BASE. This enables Add Week, Lock Game, Save Ineligible Teams.
      if (method !== 'GET'
          && ADMIN_BASE && DEFAULT_BASE
          && typeof urlStr === 'string' && urlStr.startsWith(DEFAULT_BASE)
          && (pathname.startsWith('/api/weeks') || pathname.startsWith('/api/games')) ) {
        const rewritten = ADMIN_BASE + urlStr.slice(DEFAULT_BASE.length);
        try {
          if (typeof input === 'string') {
            return origFetch(rewritten, init);
          }
          const req = new Request(rewritten, input);
          return origFetch(req, init);
        } catch {
          return origFetch(rewritten, init);
        }
      }

      // GET: route to READ base (from default base)
      if (method === 'GET' && READ_BASE && DEFAULT_BASE && typeof urlStr === 'string' && urlStr.startsWith(DEFAULT_BASE)) {
        const rewritten = READ_BASE + urlStr.slice(DEFAULT_BASE.length);
        if (typeof input === 'string') {
          return origFetch(rewritten, init);
        }
        try {
          const req = new Request(rewritten, input);
          return origFetch(req, init);
        } catch {
          return origFetch(rewritten, init);
        }
      }

      // Non-GET: route to WRITE base (from default base)
      if (method !== 'GET' && WRITE_BASE && DEFAULT_BASE && typeof urlStr === 'string' && urlStr.startsWith(DEFAULT_BASE)) {
        const rewritten = WRITE_BASE + urlStr.slice(DEFAULT_BASE.length);
        if (typeof input === 'string') {
          return origFetch(rewritten, init);
        }
        try {
          const req = new Request(rewritten, input);
          return origFetch(req, init);
        } catch {
          return origFetch(rewritten, init);
        }
      }

      return origFetch(input, init);
    } catch {
      return origFetch(input, init);
    }
  };
}
